import { render, staticRenderFns } from "./gc-sales-um-dropdown.vue?vue&type=template&id=2e9a0c46&scoped=true"
import script from "./gc-sales-um-dropdown.vue?vue&type=script&lang=js"
export * from "./gc-sales-um-dropdown.vue?vue&type=script&lang=js"
import style0 from "./gc-sales-um-dropdown.vue?vue&type=style&index=0&id=2e9a0c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a0c46",
  null
  
)

export default component.exports